import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@company-mrv/mrv-design-system/components";
import * as Styled from "./styles";

const LargeModal = ({ onRequestClose, show, children }) => (
  <Styled.Modal isOpen={show} onRequestClose={onRequestClose}>
    <Modal.Header onCloseClick={onRequestClose} />
    {children}
  </Styled.Modal>
);

LargeModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default LargeModal;
